<template>
    <BreadCrumb PageTitle="Ajouter un apropos " />
    <AddApropos />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddApropos from "../../components/Apropos/AddApropos.vue";
  
    export default defineComponent({
      name: "AddAproposPage",
      components: {
        BreadCrumb,
        AddApropos,
      },
    });
  </script>